var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "grid activitysettings" },
    [
      _c("caption", { staticClass: "sr-only" }, [
        _vm._v(
          _vm._s(_vm.t("activity", "Activity notification configuration"))
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.activityGroups, function (group, groupKey) {
        return _c(
          "tbody",
          { key: groupKey },
          [
            _c(
              "tr",
              { staticClass: "group-header" },
              [
                _c("th", [_c("b", [_vm._v(_vm._s(group.name))])]),
                _vm._v(" "),
                _vm._l(_vm.methods, function (methodName, methodKey) {
                  return _c(
                    "th",
                    {
                      key: methodKey,
                      staticClass: "activity_select_group",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(methodName) + "\n\t\t\t")]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(group.activities, function (activity, activityKey) {
              return _c(
                "tr",
                { key: activityKey },
                [
                  _c(
                    "th",
                    {
                      staticClass: "activity_select_group",
                      attrs: { scope: "row" },
                    },
                    [
                      _c("label", {
                        domProps: { innerHTML: _vm._s(activity.desc) },
                        on: {
                          click: function ($event) {
                            return _vm.toggleMethodsForActivity({
                              groupKey: groupKey,
                              activityKey: activityKey,
                            })
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.methods, function (methodName, methodKey) {
                    return _c(
                      "td",
                      { key: methodKey },
                      [
                        _c(
                          "Checkbox",
                          {
                            attrs: {
                              value: "1",
                              id: activityKey + "_" + methodKey,
                              disabled: !_vm.isActivityEnabled(
                                activity,
                                methodKey
                              ),
                              checked: _vm.checkedActivities,
                              value: activityKey + "_" + methodKey,
                            },
                            on: {
                              "update:checked": function ($event) {
                                return _vm.toggleMethodForMethodAndActivity({
                                  groupKey: groupKey,
                                  activityKey: activityKey,
                                  methodKey: methodKey,
                                })
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.actionName(methodKey)) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }